import { NewForgeButton } from "./NewForgeButton";

const ForgeSection = () => {
  // Simplified Forge sidebar - just shows button to navigate to /agents dashboard
  // No more accordion, no more chat lists under agents
  // Agent tiles are shown in /agents dashboard page
  return (
    <>
      <NewForgeButton />
    </>
  );
};

export default ForgeSection;
